var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('select',_vm._g(_vm._b({domProps:{"value":_vm.value},on:{"input":_vm.onInput}},'select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.filteredTours),function(tour){return _c('option',{key:tour.id,domProps:{"value":tour.id,"selected":tour.id === _vm.value}},[_vm._v(" "+_vm._s(tour.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }